<template>
  <div v-if="dataNotNull" key="1" class="nationalityDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_nationality">Nationality
    </div>
    <div class="zero_nationality">No Data !</div>
  </div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: "nationality",
  props: ['project_id'],
  data() {
    return {
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "nationality",
      dataNotNull: true
    }
  },
  methods: {
    init() {
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = []
      var series = []
      for (var i in result) {
        legends.push(result[i].nation_type)
        series.push({name: result[i].nation_type, value: result[i].nation_num})
      }
      return {legends: legends, series: series}
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    this.myChart = echarts.init(document.querySelector('.nationalityDiv .container1'))
    this.myChart.setOption({
      title: {
        text: "Nationality",
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'vertical',
        x: 'right',
        left: '45%',
        top: 'middle',
        itemGap: 18,
        itemHeight: '8',
        textStyle: {
          color: '#FFF',
          fontSize: '10'
        },
        data: []
      },
      series: [{
        name: 'Nationality',
        data: [],
        type: 'pie',
        hoverOffset: 5,
        radius: ['35%', '55%'],
        center: ['20%', '50%'],
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: '{c}'
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '15',
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },

        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            borderWidth: 1,
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      project_id: this.project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjNationality", postData).then(resp => {    //生产
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result);
        if (this.dataNotNull) {
          this.myChart.setOption({
            legend: {
              data: data.legends,
              itemGap: 6,
            },
            series: [{
              data: data.series
            }]
          })
        }
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
    // this.init()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_nationality
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_nationality
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/manpower/nationality.vue